import { useCallback } from 'react'
import { AgxDropdown, AgxRow, AgxTextInput } from '@urbanx/agx.ui-components2'
import { Deposit, ValueType } from '@urbanx/agx.campaigns.client'
import { parseNumber } from 'utils/parseNumber'

export const QldDepositOptions = [
  { label: ValueType.Dollar, value: ValueType.Dollar },
  { label: ValueType.Percentage, value: ValueType.Percentage },
]

interface QldDepositOptionsProps {
  id: string
  depositValue: ValueType
  onDepositValueChange: (value: ValueType) => void
  onDepositChange: (updater: (prev: Deposit | undefined) => Deposit) => void
}

export function QldDepositOptionsComponent({
  id,
  depositValue,
  onDepositValueChange,
  onDepositChange,
}: QldDepositOptionsProps) {
  const handleAmountChange = useCallback(
    (value: string | undefined) => {
      if (depositValue === ValueType.Percentage) {
        onDepositChange((prev) => ({
          ...prev,
          percent: value ? parseNumber(value) : undefined,
          amount: undefined,
          depositValueType: ValueType.Percentage,
        }))
      } else {
        onDepositChange((prev) => ({
          ...prev,
          amount: value ? parseNumber(value) : undefined,
          percent: undefined,
          depositValueType: ValueType.Dollar,
        }))
      }
    },
    [depositValue, onDepositChange]
  )

  return (
    <AgxRow gap="spacing-md" fill>
      <AgxDropdown
        options={QldDepositOptions}
        id={`select-${id}`}
        onChange={(value) => onDepositValueChange(value as ValueType)}
        selected={depositValue}
        hideOptionalText
        required
      />
      {depositValue === ValueType.Percentage && (
        <AgxTextInput
          id={`${id}-amount`}
          type="percent"
          stretch
          hideOptionalText
          onChange={handleAmountChange}
        />
      )}
      {depositValue === ValueType.Dollar && (
        <AgxTextInput
          id={`${id}-amount`}
          type="currency"
          stretch
          hideOptionalText
          onChange={handleAmountChange}
        />
      )}
    </AgxRow>
  )
}
